import type { DeliveryData } from '@consumer/services/order'
import { isContact, isUser } from '@consumer/utils/types'

export const isVerifiedRecipientAddress = (delivery: DeliveryData) => {
  return (isUser(delivery.recipient))
    || (isContact(delivery.recipient) && delivery.recipientAddressSource === 'user')
}
